import { render, staticRenderFns } from "./DurationVsWeightChart.vue?vue&type=template&id=1f98f464&scoped=true&"
import script from "./DurationVsWeightChart.vue?vue&type=script&lang=js&"
export * from "./DurationVsWeightChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f98f464",
  null
  
)

export default component.exports